<template>
  <div class="tracking-notice">
    <div class="tracking-notice-inner">
      <div class="text" v-html="setting.cookie_notice"></div>
      <button class="button decline" @click="hideOverlay()">
        Weg damit
      </button>

      <button class="button accept" @click="enableTracking()">
        Akzeptieren
      </button>
    </div>
  </div>
</template>

<script>
import { bootstrap } from 'vue-gtag'
import query from '@/services/api/query';

export default {
  name: 'tracking-notice',
  data() {
    return {
      setting: {},
    };
  },
  methods: {
    enableTracking() {
      bootstrap().then(() => {
        this.$eventBus.$emit(this.$events('GLOBAL.HIDE_TRACKING_NOTICE'))
        localStorage.setItem('PROFUNDA.COOKIE_NOTICE', 'true')
      })
    },
    hideOverlay() {
      this.$eventBus.$emit(this.$events('GLOBAL.HIDE_TRACKING_NOTICE'))
      localStorage.setItem('PROFUNDA.COOKIE_NOTICE', 'true')
    },
  },
  apollo: {
    setting: {
      query: query.cookie,
    }
  },
};
</script>